(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["o11-accessory-landing"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('o11-accessory')) {
  customElements.define('o11-accessory', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      const form = this.querySelector('form');
      const button = this.querySelector('[name="add"]');
      const label = button.querySelector('span');
      const originalLabel = label.textContent;
      const status = this.querySelector('[role="status"]');
      this.querySelectorAll('[data-thumb]').forEach(thumb => thumb.addEventListener('click', () => {
        this.querySelectorAll('[data-photo]').forEach(photo => photo.hidden = photo.dataset.photo !== thumb.dataset.thumb);
        this.querySelectorAll('[data-thumb]').forEach(item => item.setAttribute('aria-pressed', String(item === thumb)));
      }));
      const select = form.querySelector('select[name="id"]');
      select?.addEventListener('change', () => {
        const option = select.selectedOptions[0];
        if (option.dataset.price) this.querySelector('[data-price]').textContent = option.dataset.price;
      });
      form.addEventListener('submit', async event => {
        event.preventDefault();
        if (!form.reportValidity() || button.disabled) return;
        button.disabled = true;
        button.setAttribute('aria-busy', 'true');
        label.textContent = this.dataset.adding;
        status.textContent = '';
        try {
          const response = await fetch(this.dataset.addUrl, {method:'POST',headers:{Accept:'application/json'},body:new FormData(form)});
          const result = await response.json();
          if (!response.ok) throw new Error(result.description || this.dataset.error);
          window.location.assign(this.dataset.cartUrl);
        } catch(error) {
          status.textContent = error.message || this.dataset.error;
          button.disabled = false;
          button.removeAttribute('aria-busy');
          label.textContent = originalLabel;
        }
      });
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["o11-app-band"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', (event) => {
    const help = event.target.closest('[data-app-help]');
    if (help) {
      const details = document.getElementById('o11-app-help');
      if (details) details.open = true;
    }
    const preview = event.target.closest('[data-app-preview]');
    if (preview) {
      const video = preview.closest('.o11-app-feature').querySelector('.o11-training-video');
      if (video) video.play().catch(() => {});
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["o11-catalog"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('o11-catalog')) customElements.define('o11-catalog',class extends HTMLElement{
    connectedCallback(){
      if(this.ready)return;this.ready=true;
      this.cards=Array.from(this.querySelectorAll('[data-product-card]'));
      this.buttons=Array.from(this.querySelectorAll('[data-category-button]'));
      this.category='all';this.stock=this.querySelector('[data-in-stock]');
      this.sort=this.querySelector('select[name="sort_by"]');
      this.sort?.addEventListener('change',()=>{const url=new URL(location.href);this.sort.value?url.searchParams.set('sort_by',this.sort.value):url.searchParams.delete('sort_by');url.searchParams.delete('page');url.hash='o11-products';location.assign(url.toString());});
      if(this.dataset.complete!=='true')return;
      const params=new URLSearchParams(location.search);const saved=params.get('o11_category');
      if(this.buttons.some(b=>b.dataset.categoryButton===saved)||saved==='accessories')this.category=saved;
      if(this.stock)this.stock.checked=params.get('o11_stock')==='1';
      this.buttons.forEach(button=>{const category=button.dataset.categoryButton;const count=this.cards.filter(card=>this.matchesCategory(card,category)).length;button.hidden=category!=='all'&&count===0;button.querySelector('[data-category-count]').textContent=String(count);button.addEventListener('click',()=>{this.category=category;this.update(true);});});
      this.stock?.addEventListener('change',()=>this.update(true));
      this.querySelector('[data-reset-catalog]')?.addEventListener('click',event=>{event.preventDefault();this.category='all';if(this.stock)this.stock.checked=false;this.update(true);});
      this.querySelector('[data-category-controls]').hidden=false;this.querySelector('[data-stock-control]').hidden=false;
      this.update(false);
    }
    matchesCategory(card,category){return category==='all'||category===card.dataset.category||category==='accessories'&&card.dataset.category!=='mats';}
    update(changeUrl){let count=0;this.cards.forEach(card=>{const visible=this.matchesCategory(card,this.category)&&(!this.stock?.checked||card.dataset.available==='true');card.closest('.o11-catalog-cell').hidden=!visible;if(visible)count++;});this.buttons.forEach(button=>button.setAttribute('aria-pressed',String(button.dataset.categoryButton===this.category)));this.querySelector('[data-catalog-count]').textContent=(count===1?this.dataset.countOne:this.dataset.countMany).replace('[count]',String(count));this.querySelector('[data-catalog-empty]').hidden=count>0;if(changeUrl){const url=new URL(location.href);this.category==='all'?url.searchParams.delete('o11_category'):url.searchParams.set('o11_category',this.category);this.stock?.checked?url.searchParams.set('o11_stock','1'):url.searchParams.delete('o11_stock');url.hash='o11-products';history.replaceState(history.state,'',url.toString());}}
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["o11-home-footer"]) return;
  try {
    
  if(!customElements.get('o11-home-footer'))customElements.define('o11-home-footer',class extends HTMLElement{connectedCallback(){if(this.ready)return;this.ready=true;this.update=()=>{const mobile=document.body.getBoundingClientRect().width<=749;if(this.mobile===mobile)return;this.mobile=mobile;this.querySelectorAll('details').forEach(item=>{item.open=!mobile;});};this.observer=new ResizeObserver(this.update);this.observer.observe(document.body);this.update();}disconnectedCallback(){this.observer?.disconnect();}});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["o11-home-products"] && !Shopify.designMode) return;
  try {
    
  if(!customElements.get('o11-product-carousel'))customElements.define('o11-product-carousel',class extends HTMLElement{
    connectedCallback(){if(this.ready)return;this.ready=true;this.track=this.querySelector('[data-carousel-track]');this.prev=this.querySelector('[data-carousel-prev]');this.next=this.querySelector('[data-carousel-next]');this.progress=this.querySelector('[data-carousel-progress]');this.prev.addEventListener('click',()=>this.move(-1));this.next.addEventListener('click',()=>this.move(1));this.track.addEventListener('scroll',()=>this.update(),{passive:true});this.track.addEventListener('keydown',event=>{if(event.target!==this.track)return;if(event.key==='ArrowRight'||event.key==='ArrowLeft'){event.preventDefault();this.move(event.key==='ArrowRight'?1:-1);}});this.resizeObserver=new ResizeObserver(()=>this.update());this.resizeObserver.observe(this.track);this.update();}
    disconnectedCallback(){this.resizeObserver?.disconnect();}
    move(direction){const card=this.track.firstElementChild;if(!card)return;const gap=parseFloat(getComputedStyle(this.track).columnGap)||0;this.track.scrollBy({left:direction*(card.getBoundingClientRect().width+gap),behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth'});}
    update(){const max=this.track.scrollWidth-this.track.clientWidth;const pos=Math.max(0,this.track.scrollLeft);this.prev.disabled=pos<3;this.next.disabled=pos>=max-3;this.querySelector('[data-carousel-controls]').hidden=max<3;const ratio=Math.min(1,this.track.clientWidth/this.track.scrollWidth);this.progress.style.width=`${ratio*100}%`;this.progress.style.transform=`translateX(${max>0?Math.min(pos/max,1)*(1-ratio)/ratio*100:0}%)`;}
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["o11-landing-header"]) return;
  try {
    
  if (!customElements.get('o11-announcements')) {
    customElements.define('o11-announcements', class extends HTMLElement {
      connectedCallback() {
        this.controller = new AbortController();
        const options = { signal: this.controller.signal };
        this.motion = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.paused = this.dataset.autoplay !== 'true' || this.motion.matches;
        this.static = this.paused;
        this.speed = Math.max(20, Math.min(60, Number(this.dataset.speed) || 35));
        this.toggle = this.querySelector('[data-announcement-toggle]');
        this.track = this.querySelector('.o11-announcement-track');
        this.group = this.querySelector('.o11-announcement-group');
        this.viewport = this.querySelector('.o11-announcement-viewport');
        this.querySelector('.o11-announcement-controls').hidden = false;
        this.classList.add('is-ready');
        this.toggle.addEventListener('click', () => {
          this.paused = !this.paused;
          if (!this.paused) this.static = false;
          this.sync();
        }, options);
        document.addEventListener('visibilitychange', () => this.sync(), options);
        this.motion.addEventListener('change', event => {
          if (event.matches) { this.paused = true; this.static = true; }
          this.sync();
        }, options);
        this.sync();
        this.resizeObserver = new ResizeObserver(() => this.updateSpeed());
        this.resizeObserver.observe(this.viewport);
        this.resizeObserver.observe(this.group);
        document.fonts.ready.then(() => { if (this.isConnected) this.updateSpeed(); });
      }
      disconnectedCallback() {
        this.controller?.abort();
        this.resizeObserver?.disconnect();
      }
      updateSpeed() {
        const width = this.group.getBoundingClientRect().width;
        this.style.setProperty('--o11-marquee-duration', `${Math.max(5, width / this.speed)}s`);
      }
      sync() {
        this.classList.toggle('is-static', this.static);
        this.classList.toggle('is-paused', this.paused || document.hidden);
        this.toggle.setAttribute('aria-label', this.paused ? this.toggle.dataset.playLabel : this.toggle.dataset.pauseLabel);
        this.toggle.querySelector('[data-pause-icon]').toggleAttribute('hidden', this.paused);
        this.toggle.querySelector('[data-play-icon]').toggleAttribute('hidden', !this.paused);
        this.updateSpeed();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["o11-mat-first"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('o11-mat-first')) {
    customElements.define('o11-mat-first', class extends HTMLElement {
      connectedCallback() {
        if (this.ready) {
          if (this.extrasTrack) this.extrasObserver?.observe(this.extrasTrack);
          if (this.stickyBar) { this.stickyObserver?.observe(this.mainButton); this.stickySizeObserver?.observe(this.stickyBar); }
          return;
        }
        this.ready = true;
        this.extrasTrack = this.querySelector('.o11-mf-addon-list');
        if (this.extrasTrack) {
          const pagination = this.querySelector('[data-extras-pagination]');
          const cards = [...this.extrasTrack.querySelectorAll('[data-extras-card]')];
          const indicators = [...pagination.querySelectorAll('[data-extras-target]')];
          let activeIndex = 0;
          const positions = () => {
            const maximum = this.extrasTrack.scrollWidth - this.extrasTrack.clientWidth;
            const start = this.extrasTrack.getBoundingClientRect().left;
            return cards.map(card => Math.max(0, Math.min(maximum, this.extrasTrack.scrollLeft + card.getBoundingClientRect().left - start - 2)));
          };
          const updateExtras = () => {
            const maximum = this.extrasTrack.scrollWidth - this.extrasTrack.clientWidth;
            pagination.hidden = maximum < 2;
            const stops = positions();
            activeIndex = stops.reduce((best, stop, index) => Math.abs(stop - this.extrasTrack.scrollLeft) < Math.abs(stops[best] - this.extrasTrack.scrollLeft) ? index : best, 0);
            indicators.forEach((button, index) => button.setAttribute('aria-current', String(index === activeIndex)));
          };
          const showExtra = index => {
            const stop = positions()[Math.max(0, Math.min(cards.length - 1, index))];
            this.extrasTrack.scrollTo({left:stop, behavior:matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'});
          };
          indicators.forEach((button, index) => button.addEventListener('click', () => showExtra(index)));
          this.extrasTrack.addEventListener('keydown', event => {
            if (event.target !== this.extrasTrack || !['ArrowLeft','ArrowRight'].includes(event.key)) return;
            event.preventDefault();
            showExtra(activeIndex + (event.key === 'ArrowRight' ? 1 : -1));
          });
          this.extrasTrack.addEventListener('scroll', updateExtras, {passive:true});
          this.extrasObserver = new ResizeObserver(updateExtras);
          this.extrasObserver.observe(this.extrasTrack);
          updateExtras();
        }
        this.querySelectorAll('[data-gallery]').forEach(button => button.addEventListener('click', () => {
          this.querySelectorAll('[data-panel]').forEach(panel => {
            panel.hidden = panel.dataset.panel !== button.dataset.gallery;
            if (panel.hidden) panel.querySelector('video')?.pause();
          });
          this.querySelectorAll('[data-gallery]').forEach(item => item.setAttribute('aria-pressed', String(item === button)));
        }));
        const quantity = this.querySelector('.o11-mf-quantity input');
        this.querySelectorAll('[data-quantity-step]').forEach(button => button.addEventListener('click', () => {
          quantity.value = String(Math.max(1, (parseInt(quantity.value, 10) || 1) + Number(button.dataset.quantityStep)));
          quantity.dispatchEvent(new Event('change', {bubbles:true}));
        }));
        this.querySelectorAll('form').forEach(form => {
          const button = form.querySelector('[data-submit]');
          if (!button) return;
          button.dataset.label = button.textContent.trim();
          form.addEventListener('submit', event => {
            if (event.submitter && event.submitter !== button) return;
            this.addProduct(event, form, button);
          });
        });
        this.mainForm = this.querySelector('.o11-mf-main-form');
        this.mainButton = this.mainForm.querySelector('[data-submit]');
        this.stickyBar = this.querySelector('[data-sticky-cart]');
        this.stickyButton = this.querySelector('[data-sticky-submit]');
        if (this.stickyBar) {
          this.stickyButton.dataset.label = this.stickyButton.textContent.trim();
          this.stickyButton.addEventListener('click', () => {
            if (!this.mainButton.disabled) this.mainForm.requestSubmit(this.mainButton);
          });
          this.stickyObserver = new IntersectionObserver(([entry]) => {
            const hidden = entry.isIntersecting || entry.boundingClientRect.bottom > 0;
            if (hidden && this.stickyBar.contains(document.activeElement)) this.mainButton.focus({preventScroll:true});
            this.stickyBar.hidden = hidden;
          });
          this.stickyObserver.observe(this.mainButton);
          this.stickySizeObserver = new ResizeObserver(() => {
            if (!this.stickyBar.hidden) document.body.style.setProperty('--o11-mf-sticky-height', `${this.stickyBar.offsetHeight}px`);
          });
          this.stickySizeObserver.observe(this.stickyBar);
        }
      }
      disconnectedCallback() {
        this.extrasObserver?.disconnect();
        this.stickyObserver?.disconnect();
        this.stickySizeObserver?.disconnect();
      }
      async addProduct(event, form, button) {
        event.preventDefault();
        if (button.disabled || !form.reportValidity()) return;
        const status = form.querySelector('[data-status]');
        const stickyStatus = form === this.mainForm ? this.querySelector('[data-sticky-status]') : null;
        const buttons = [button, form === this.mainForm ? this.stickyButton : null].filter(Boolean);
        status.textContent = '';
        status.removeAttribute('data-success');
        if (stickyStatus) stickyStatus.textContent = '';
        buttons.forEach(item => {
          item.disabled = true;
          item.setAttribute('aria-busy', 'true');
          item.textContent = this.dataset.adding;
        });
        try {
          const response = await fetch(this.dataset.addUrl, {method:'POST', headers:{Accept:'application/json'}, body:new FormData(form)});
          const result = await response.json();
          if (!response.ok) throw new Error(result.description || this.dataset.error);
          if (form.classList.contains('o11-mf-main-form')) {
            window.location.assign(this.dataset.cartUrl);
            return;
          }
          button.textContent = this.dataset.added;
          status.setAttribute('data-success', '');
          status.textContent = this.dataset.added;
          form.querySelector('[data-view-cart]').hidden = false;
          this.updateCartCount();
        } catch (error) {
          buttons.forEach(item => { item.disabled = false; item.textContent = item.dataset.label; });
          status.textContent = error.message || this.dataset.error;
          if (stickyStatus) stickyStatus.textContent = status.textContent;
        } finally {
          buttons.forEach(item => item.removeAttribute('aria-busy'));
        }
      }
      async updateCartCount() {
        try {
          const response = await fetch(this.dataset.cartJsonUrl, {headers:{Accept:'application/json'}});
          if (!response.ok) return;
          const cart = await response.json();
          document.querySelectorAll('.o11-cart').forEach(link => {
            let badge = link.querySelector('span');
            if (!badge) { badge = document.createElement('span'); link.append(badge); }
            badge.textContent = cart.item_count;
          });
        } catch (error) {}
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["o11-native-product"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('o11-native-accessory')) {
  customElements.define('o11-native-accessory', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      const form = this.querySelector('form');
      const button = this.querySelector('[name="add"]');
      const label = button.querySelector('span');
      const status = this.querySelector('[role="status"]');
      this.querySelectorAll('[data-thumb]').forEach(thumb => thumb.addEventListener('click', () => {
        this.querySelectorAll('[data-photo]').forEach(photo => photo.hidden = photo.dataset.photo !== thumb.dataset.thumb);
        this.querySelectorAll('[data-thumb]').forEach(item => item.setAttribute('aria-pressed', String(item === thumb)));
      }));
      form.querySelectorAll('input[type="radio"][name="id"]').forEach(input => input.addEventListener('change', () => {
        if (!input.checked) return;
        this.querySelector('[data-price]').textContent = input.dataset.price;
        const compare = this.querySelector('[data-compare]');
        compare.textContent = input.dataset.compare;
        compare.hidden = !input.dataset.compare;
        button.disabled = input.disabled;
        label.textContent = input.disabled ? this.dataset.soldOut : this.dataset.addLabel;
        status.textContent = '';
        const url = new URL(window.location.href);
        url.searchParams.set('variant', input.value);
        window.history.replaceState({}, '', url);
        if (input.dataset.imageId) {
          const photo = this.querySelector('[data-photo][data-image-id="' + input.dataset.imageId + '"]');
          if (photo) this.querySelector('[data-thumb="' + photo.dataset.photo + '"]')?.click();
        }
      }));
      form.addEventListener('submit', async event => {
        event.preventDefault();
        if (!form.reportValidity() || button.disabled) return;
        button.disabled = true;
        button.setAttribute('aria-busy', 'true');
        label.textContent = this.dataset.adding;
        status.textContent = '';
        try {
          const response = await fetch(this.dataset.addUrl, {method:'POST',headers:{Accept:'application/json'},body:new FormData(form)});
          const result = await response.json();
          if (!response.ok) throw new Error(result.description || this.dataset.error);
          const cartUrl = new URL(this.dataset.cartUrl, window.location.origin);
          const previewId = this.dataset.previewThemeId || new URL(window.location.href).searchParams.get('preview_theme_id');
          if (previewId) cartUrl.searchParams.set('preview_theme_id', previewId);
          window.location.assign(cartUrl.href);
        } catch(error) {
          status.textContent = error.message || this.dataset.error;
          button.disabled = false;
          button.removeAttribute('aria-busy');
          label.textContent = this.dataset.addLabel;
        }
      });
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["o11-product-landing"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('o11-product')) {
    customElements.define('o11-product', class extends HTMLElement {
      connectedCallback() {
        if (this.ready) return;
        this.ready = true;
        this.form = this.querySelector('form');
        if (!this.form) return;
        this.size = this.querySelector('[data-size]');
        this.mat = this.querySelector('[data-mat-variant]');
        this.add = this.querySelector('[data-add]');
        this.status = this.querySelector('[data-status]');
        this.mobileBuy = this.querySelector('[data-mobile-buy]');
        this.mobileAdd = this.querySelector('[data-mobile-add]');
        this.sizeDialog = this.querySelector('[data-size-dialog]');
        this.querySelector('[data-size-guide]')?.addEventListener('click', event => {
          if (!this.sizeDialog?.showModal) return;
          event.preventDefault();
          event.stopPropagation();
          this.sizeDialog.showModal();
        });
        this.querySelector('[data-close-size]')?.addEventListener('click', () => this.sizeDialog.close());
        this.sizeDialog?.addEventListener('click', event => {
          if (event.target !== this.sizeDialog) return;
          const rect = this.sizeDialog.getBoundingClientRect();
          if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) this.sizeDialog.close();
        });
        this.mobileAdd?.addEventListener('click', () => {
          if (this.add.disabled) return;
          if (this.size.required && !this.size.value) {
            this.querySelector('[data-size-wrap]').scrollIntoView({behavior:'smooth',block:'center'});
            this.size.focus({preventScroll:true});
            return;
          }
          this.form.requestSubmit(this.add);
        });
        if (this.mobileBuy && 'IntersectionObserver' in window) {
          this.buyObserver = new IntersectionObserver(entries => {
            this.mobileBuy.hidden = entries[0].intersectionRatio >= 0.5;
          }, {threshold:0.5});
          this.buyObserver.observe(this.add);
        }

        this.addEventListener('change', (event) => {
          if (event.target.name === 'o11_set') {
            this.update();
            this.gallery(event.target.value);
            if (event.target.value === 'bundle') this.size.dispatchEvent(new Event('change', {bubbles:true}));
          }
          if (event.target === this.size) this.update();
        });
        this.querySelectorAll('[data-gallery]').forEach(button => button.addEventListener('click', () => this.gallery(button.dataset.gallery)));
        this.querySelector('.o11-review-link')?.addEventListener('click', event => {
          const reviews = document.getElementById('o11-reviews');
          if (!reviews) return;
          event.preventDefault();
          reviews.focus({preventScroll:true});
          reviews.scrollIntoView({behavior:window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth',block:'start'});
          history.replaceState(null, '', '#o11-reviews');
        });
        this.form.addEventListener('submit', (event) => { if (event.submitter === this.add) this.submit(event); });
        this.update();
        this.gallery(this.querySelector('input[name="o11_set"]:checked').value);
      }
      disconnectedCallback() {
        this.buyObserver?.disconnect();
      }
      gallery(name) {
        this.querySelectorAll('[data-gallery-panel]').forEach(panel => {
          panel.hidden = panel.dataset.galleryPanel !== name;
          const video = panel.querySelector('video');
          if (video && panel.hidden) video.pause();
          if (video && !panel.hidden) video.play().catch(() => {});
        });
        this.querySelectorAll('[data-gallery]').forEach(button => button.setAttribute('aria-pressed', String(button.dataset.gallery === name)));
        const active = this.querySelector('[data-gallery="' + name + '"]');
        const caption = this.querySelector('[data-gallery-caption]');
        const text = active?.dataset.caption || '';
        caption.textContent = text;
        caption.hidden = !text;
      }
      chooseBundle() {
        this.querySelector('input[value="bundle"]').checked = true;
        this.update();
        this.gallery('bundle');
        this.size.dispatchEvent(new Event('change', {bubbles:true}));
        this.size.focus({preventScroll:true});
      }
      update() {
        const isBundle = this.querySelector('input[name="o11_set"]:checked').value === 'bundle';
        const delivery = this.querySelector('[data-product-delivery]');
        if (delivery) delivery.querySelector('[data-delivery-cost]').textContent = (isBundle ? delivery.dataset.bundleDelivery : delivery.dataset.matDelivery).replace(/^\+\s*/, '');
        this.size.disabled = !isBundle;
        this.size.required = isBundle;
        this.mat.disabled = isBundle;
        this.querySelector('[data-size-wrap]').hidden = !isBundle;
        this.querySelector('[data-size-helper]').hidden = !isBundle || Boolean(this.size.value);
        const option = this.size.options[this.size.selectedIndex];
        const price = isBundle ? option.dataset.price : this.mat.dataset.price;
        const available = isBundle ? Array.from(this.size.options).some(item => item.value && !item.disabled) : this.mat.dataset.available === 'true';
        const bundleExpress = this.querySelector('[data-fast-buy="bundle"]');
        const matExpress = this.querySelector('[data-fast-buy="mat"]');
        const bundleReady = isBundle && Boolean(this.size.value) && !option.disabled && available;
        if (bundleExpress) {
          const variant = bundleExpress.querySelector('[data-express-bundle-variant]');
          const selected = bundleReady ? this.size.value : '';
          const changed = variant.value !== selected || variant.disabled === bundleReady;
          variant.value = selected;
          variant.disabled = !bundleReady;
          if (changed) variant.dispatchEvent(new Event('change', {bubbles:true}));
          bundleExpress.hidden = !bundleReady;
        }
        if (matExpress) matExpress.hidden = isBundle || !available;
        this.add.disabled = !available;
        this.querySelector('[data-add-text]').textContent = available ? this.dataset.addLabel + ' — ' + price : this.dataset.soldOut;
        if (this.mobileAdd) {
          this.mobileAdd.disabled = !available;
          this.mobileAdd.textContent = !available ? this.dataset.soldOut : (isBundle && !this.size.value ? this.dataset.chooseSizeLabel : this.dataset.addLabel) + ' — ' + price;
        }

        if (isBundle) {
          this.querySelector('[data-bundle-price]').textContent = price;
          if (option.value) this.querySelectorAll('[data-bundle-saving]').forEach(item => item.hidden = item.dataset.bundleSaving !== option.value);
        }
        this.status.textContent = '';
      }
      async submit(event) {
        event.preventDefault();
        if (!this.form.reportValidity() || this.add.disabled) return;
        this.add.disabled = true;
        this.add.setAttribute('aria-busy','true');
        if (this.mobileAdd) {
          this.mobileAdd.disabled = true;
          this.mobileAdd.textContent = this.dataset.addingLabel;
        }
        this.querySelector('[data-add-text]').textContent = this.dataset.addingLabel;
        this.status.textContent = '';
        try {
          const response = await fetch(this.dataset.addUrl, {method:'POST',headers:{Accept:'application/json'},body:new FormData(this.form)});
          const result = await response.json();
          if (!response.ok) throw new Error(result.description || this.dataset.errorLabel);
          window.location.assign(this.dataset.cartUrl);
        } catch (error) {
          this.update();
          this.status.textContent = error.message || this.dataset.errorLabel;
        } finally {
          this.add.removeAttribute('aria-busy');
        }
      }
    });
    document.addEventListener('click', (event) => {
      if (event.target.closest('a[href="#o11-sizes"]')) {
        const guide = document.getElementById('o11-sizes');
        if (guide) guide.open = true;
      }
      const menuLink = event.target.closest('.o11-menu nav a');
      if (menuLink) menuLink.closest('details').open = false;
      const link = event.target.closest('[data-choose-bundle]');
      if (!link) return;
      const product = document.querySelector('o11-product');
      if (product && typeof product.chooseBundle === 'function') product.chooseBundle();
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["o11-reviews-faq"] && !Shopify.designMode) return;
  try {
    
  if (window.Shopify && window.Shopify.designMode) {
    document.addEventListener('shopify:block:select', (event) => {
      const review = event.target.closest('.o11-more-review-card');
      if (!review) return;
      const dropdown = review.closest('.o11-more-reviews');
      if (dropdown) dropdown.open = true;
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["o11-socks-product"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('o11-socks')) {
  customElements.define('o11-socks', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      const options = {signal:this.controller.signal};
      this.form = this.querySelector('.o11-socks-form');
      this.add = this.querySelector('[data-socks-add]');
      this.label = this.querySelector('[data-socks-add-text]');
      this.status = this.querySelector('[data-socks-status]');
      this.busy = false;
      if (!this.form || !this.querySelector('[data-pack-radio]')) return;
      if (!this.querySelector('[data-pack-radio]:checked')) this.querySelector('[data-pack-radio]').checked = true;
      this.addEventListener('change', event => {
        if (event.target.matches('[data-pack-radio]')) this.updatePack();
        if (event.target.matches('[data-pair-size]')) this.status.textContent = '';
      }, options);
      this.addEventListener('click', event => {
        const thumb = event.target.closest('[data-socks-thumb]');
        if (thumb) this.showPhoto(thumb.dataset.socksThumb);
      }, options);
      this.form.addEventListener('submit', event => this.submit(event), options);
      document.addEventListener('shopify:block:select', event => {
        const photo = event.target.closest('[data-socks-image]');
        if (photo && this.contains(photo)) this.showPhoto(photo.dataset.socksImage);
        const card = event.target.closest('[data-pack-card]');
        if (card && this.contains(card)) { card.querySelector('[data-pack-radio]').checked = true; this.updatePack(); }
      }, options);
      this.updatePack();
    }
    disconnectedCallback() { this.controller?.abort(); this.controller = null; }
    showPhoto(index) {
      this.querySelectorAll('[data-socks-image]').forEach(photo => photo.hidden = photo.dataset.socksImage !== index);
      this.querySelectorAll('[data-socks-thumb]').forEach(thumb => thumb.setAttribute('aria-pressed', String(thumb.dataset.socksThumb === index)));
    }
    updatePack() {
      this.querySelectorAll('[data-pack-card]').forEach(card => {
        const active = card.querySelector('[data-pack-radio]').checked;
        card.querySelector('[data-pack-sizes]').hidden = !active;
        card.querySelectorAll('[data-pair-size]').forEach(select => {select.disabled = !active; select.required = active;});
      });
      this.label.textContent = this.querySelector('[data-pack-radio]:checked').dataset.addLabel;
      this.status.textContent = '';
    }
    async submit(event) {
      event.preventDefault();
      if (this.busy || this.add.disabled || !this.form.reportValidity()) return;
      const selects = Array.from(this.querySelectorAll('[data-pair-size]:not(:disabled)'));
      const items = new Map();
      for (const select of selects) {
        const quantity = (items.get(select.value)?.quantity || 0) + 1;
        const stock = Number(select.selectedOptions[0].dataset.stock);
        if (stock >= 0 && quantity > stock) { this.status.textContent = this.dataset.stockError; select.focus(); return; }
        items.set(select.value, {id:Number(select.value),quantity});
      }
      if (!items.size) return;
      this.busy = true;
      this.add.disabled = true;
      this.add.setAttribute('aria-busy','true');
      this.label.textContent = this.dataset.adding;
      this.status.textContent = '';
      try {
        const response = await fetch(this.dataset.addUrl, {method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({items:Array.from(items.values())})});
        const result = await response.json();
        if (!response.ok) throw new Error(result.description || this.dataset.error);
        window.location.assign(this.dataset.cartUrl);
      } catch(error) {
        this.status.textContent = error.message || this.dataset.error;
        this.add.disabled = false;
        this.label.textContent = this.querySelector('[data-pack-radio]:checked').dataset.addLabel;
      } finally {
        this.busy = false;
        this.add.removeAttribute('aria-busy');
      }
    }
  });
}

  } catch(e) { console.error(e); }
})();
})();
